import React from 'react';
import {Button, Checkbox, Modal, Table} from "antd";
import {injectIntl} from "react-intl";
import Constants from "../../../services/Constants";
import moment from 'moment';
import connect from "react-redux/es/connect/connect";
import withAuthorization from "../../../services/Authorization";
import PlanningTable from "../../carpark/planningtable/PlanningTable";

const Column = Table.Column;

class RentalAssignModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      rentalPark: [],
      error: []
    }
  }

  componentDidMount() {
    const {startDate, endDate} = this.props.intervention;
    this.setState({
      from: moment(startDate).format(Constants.DATE_FORMAT_API),
      to: moment(endDate).add(15, 'days').format(Constants.DATE_FORMAT_API),
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.fetchInterventionRentalPark && nextProps.fetchInterventionRentalPark.rentalPark) {
      const {rentalPark} = nextProps.fetchInterventionRentalPark;
      this.setState({
        rentalPark,
      });
    }
  }

  fetchRentalPark = (page, size) => {
    const {intervention: {id}} = this.props;
    const {from, to} = this.state;
    this.props.dispatchFetchInterventionRentalPark(id, {page, size, from, to});
  };

  onDataUpdate = (page, size) => {
    this.fetchRentalPark(page, size)
  };

  onSave = () => {
    const {selectedRental} = this.state;
    const {intervention: {id}} = this.props;

    if (selectedRental) {
      this.props.dispatchAssignRentalVehicle({
        interventionId: id,
        rentalVehicleId: selectedRental
      });
    } else {
      const errors = {rentalVehicle: {message: 'error.non.selected.rental'}};
      this.setState({errors});
    }
  };

  onSelectRental = (e, rental) => {
    const selectedRental = e.target.checked ? rental.vehicleId : undefined;
    this.setState({selectedRental, errors: undefined});
  };

  checkboxColumn = () => {
    return (
      <Column
        key="rental-selector"
        fixed="left"
        width={110}       // this value must be equals to other columns width to avoid rendering issues
        render={(text, record) => {
          const {selectedRental} = this.state;
          const checked = record.rentalVehicle.vehicleId === selectedRental;
          return <Checkbox checked={checked} onChange={(e) => this.onSelectRental(e, record.rentalVehicle)}/>
        }}
      />
    )
  };

  render() {
    const {intl: {formatMessage}, fetchInterventionRentalPark: {loading, totalElements}, assignRentalVehicle: {error = {}}} = this.props;
    const {visible, onModalClose, intervention} = this.props;
    const {startDate, endDate} = intervention;
    const {rentalPark, from, to, errors = {}} = this.state;

    const {mobility: requestedMobility} = intervention.journey.properties.mobility;
    return (
      <Modal title={formatMessage({id: 'section.car-assignment.modal.title'})}
             visible={visible} onCancel={onModalClose} width={'120rem'}
             footer={[
               <Button key="save" type="primary" onClick={this.onSave}>{formatMessage({id: 'action.save'})}</Button>
             ]}>
        <div className="box__body--no-padding">
          <h3 className="box__subtitle">{formatMessage({id: 'appointment.rental.summary.title'})}</h3>
          <div className="row">
            <span className="col-md-6 col-xxl-6"><span className="txt-muted">{formatMessage({id: 'placeholder.startDate'})}:</span> {moment(startDate).format(Constants.DATE_FORMAT_DISPLAY)}</span>
            <span className="col-md-6 col-xxl-6"><span className="txt-muted">{formatMessage({id: 'placeholder.endDate'})}:</span> {moment(endDate).format(Constants.DATE_FORMAT_DISPLAY)}</span>
          </div>
          <div className="row">
            <span className="col-md-6 col-xxl-6"><span className="txt-muted">{formatMessage({id: 'vehicle.category'})}:</span> {formatMessage({id: `mobility.${requestedMobility.name}`})}</span>
          </div>

          {error && error.content && error.content.rentalVehicle &&
            <div className="alert alert--error">
              {formatMessage({id: error.content.rentalVehicle.message})}
            </div>
          }
          {errors && errors.rentalVehicle &&
            <div className="alert alert--error">
              {formatMessage({id: errors.rentalVehicle.message})}
            </div>
          }

          <h3 className="box__subtitle">{formatMessage({id: 'appointment.detail.mobility.mobility-solution.title'})}</h3>
          <PlanningTable rentalPark={rentalPark} loading={loading} totalElements={totalElements} deactivateDates={true}
                         from={from} to={to} errors={errors} additionalColumns={this.checkboxColumn()} onDataUpdate={this.onDataUpdate}
                         pageSize={5} sizeOptions={["5", "10", "25", "50"]}/>
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = state => ({
  fetchInterventionRentalPark: state.fetchInterventionRentalPark,
  assignRentalVehicle: state.assignRentalVehicle
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchInterventionRentalPark: (id, params) => dispatch({type: 'FETCH.INTERVENTION_RENTAL_PARK.REQUEST', id, params}),
  dispatchAssignRentalVehicle: (body) => dispatch({type: 'ASSIGN_RENTAL_VEHICLE.REQUEST', body}),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthorization(injectIntl(RentalAssignModal), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));
